package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class FileEntityType(private val literal: String) : IEnumType {
	Content("Content"),
	Comment("Comment"),
	Acupoint("Acupoint"),
	Medicine("Medicine"),
	SignSymptom("SignSymptom");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "file_entity_type"}
	override fun getLiteral(): String {return literal}
}
